import { useState } from 'react';

import { useEventListener } from './use-event-listener';

/**
 * Allows to track page url change outside React Router
 * */
export const useCurrentUrl = () => {
  const [currentUrl, setCurrentUrl] = useState(window.location.href);

  const handleLocationChange = () => {
    setCurrentUrl(window.location.href);
  };

  useEventListener('popstate', handleLocationChange);

  return currentUrl;
};
